module.exports = __webpack_public_path__ + "static/exterior-f6661d2da6c3df0ff1623e90af444d11.jpg";